import { googleAuthProvider, auth, database } from '../firebase/firebase';
import { signInWithPopup, signOut } from 'firebase/auth';
import { ref, set, update } from 'firebase/database';

export const login = (user) => ({
    type: 'LOGIN',
    user
});

export const startLogin = () => {
    return (dispatch, getState) => {

        return signInWithPopup(auth, googleAuthProvider).then((result) => {
            console.log("success login");

            const uid = getState().auth.uid;
            const email = getState().auth.email;
            const displayName = getState().auth.displayName;
            const photoUrl = getState().auth.photoUrl;

            console.log(uid, displayName, photoUrl);

            update(ref(database, `users/${uid}`), { email, displayName, photoUrl }).then(() => {
                console.log("saved");
            });
        })
    }
}

export const logout = () => ({
    type: 'LOGOUT'
});

export const startLogout = () => {
    return () => {
        return signOut(auth).then((result) => {
            console.log("success logout");
        });
    }
}